/**
 * Centralized "815 Digital Services" placeholder branding mark.
 *
 * Single source of truth so the real logo can later replace this text
 * wordmark by editing ONE file instead of hunting through every page
 * that references it (Login, Presentation Mode landing, Sidebar footer).
 */
export const BrandWordmark = ({ className = "", size = "sm" }) => {
  const sizeClasses = size === "sm" ? "text-[11px]" : "text-xs";
  return (
    <p className={`${sizeClasses} text-muted-foreground text-center ${className}`} data-testid="brand-wordmark">
      Powered by <span className="font-semibold text-foreground/70">815 Digital Services</span>
    </p>
  );
};
